import React, { useState, useCallback } from 'react';

import ActionModal from 'components/actionModal/ActionModal';
import Result from 'components/actionModal/stages/Result';
import { ActionModalMainContent } from 'components/actionModal/styledElements/stagesStyledElements';

import { DELEGATE_ITEM, DelegatesWindowStages } from '../models';

import AccessAccountDetails from './DelegateAccountDetails';

type CreateDelegateAccountModalProps = {
  closeModalWindow: () => void;
};

const CreateDelegateAccountModal = ({
  closeModalWindow,
}: CreateDelegateAccountModalProps) => {
  const [result, setResult] = useState('');
  const [activeStage, setActiveStage] = useState(
    DelegatesWindowStages.DelegatesDetails
  );

  const [delegateItemInfo, setDelegateItemInfo] = useState(DELEGATE_ITEM);
  const goToResultStage = useCallback(() => {
    setActiveStage(DelegatesWindowStages.Result);
  }, [setActiveStage]);

  const goToNextStep = useCallback(() => {
    setResult('Delegate account created!');
    goToResultStage();
  }, [goToResultStage]);

  return (
    <ActionModal closeModalWindow={closeModalWindow}>
      {activeStage === DelegatesWindowStages.Result ? (
        <Result
          title={result}
          description="Leila has been sent access details to the portal"
          closeModal={closeModalWindow}
        />
      ) : (
        <ActionModalMainContent>
          <AccessAccountDetails
            title="Create delegate account"
            goToNextStage={goToNextStep}
            delegateDetails={delegateItemInfo}
            setDelegateAccountItem={setDelegateItemInfo}
          />
        </ActionModalMainContent>
      )}
    </ActionModal>
  );
};

export default CreateDelegateAccountModal;
